export default "__VITE_ASSET__CtIeOc05__"